export type TaxPaymentSlipType =
  | 'darf'
  | 'das'
  | 'irpj_csll'
  | 'iss'
  | 'pis_cofins'

export type TaxPaymentSlipStatus =
  | 'pending'
  | 'approved'
  | 'recalculation_requested'

export type TaxPaymentSlip = {
  amount: string | number
  document_amount: string | number | null
  due_date: string | null
  key: string
  month: number
  paid: boolean
  paid_at: string | null
  status: TaxPaymentSlipStatus
  type: TaxPaymentSlipType
  url: string | null
  year: number
}

export const TaxPaymentSlipTypeLabel: Record<TaxPaymentSlipType, string> = {
  darf: 'DARF',
  das: 'DAS',
  irpj_csll: 'IRPJ/CSLL',
  iss: 'ISS',
  pis_cofins: 'PIS/COFINS',
}

export const TAX_PAYMENT_SLIP_TYPE_ORDER: Record<TaxPaymentSlipType, number> = {
  das: 0,
  iss: 1,
  pis_cofins: 2,
  irpj_csll: 3,
  darf: 4,
}
